/* KIZUNA 2.0 — storefront behaviour. No dependencies. */
(function () {
  'use strict';

  var KZ = window.KZ || (window.KZ = {});
  KZ.routes = KZ.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', recommendations: '/recommendations/products' };
  KZ.strings = KZ.strings || { addToCart: 'Add to cart', soldOut: 'Sold out', error: "That didn't go through. Please try again." };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* ---------- Money ---------- */
  KZ.formatMoney = function (cents, format) {
    cents = Number(cents) || 0;
    format = (format || KZ.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    function fmt(n, d, ts, ds) {
      var parts = (n / 100).toFixed(d).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts || ',') + (parts[1] ? (ds || '.') + parts[1] : '');
    }
    var key = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1];
    var v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  };

  /* ---------- Toast ---------- */
  KZ.toast = function (msg) {
    var t = $('[data-kz-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2800);
  };

  /* ---------- Focus trap ---------- */
  function trapFocus(container, e) {
    if (e.key !== 'Tab' || !container) return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------- Reveal on scroll ---------- */
  KZ.reveal = function (root) {
    var els = $$('.kz-reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    KZ._io = KZ._io || new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); KZ._io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { KZ._io.observe(el); });
  };

  /* ---------- Cart ---------- */
  var Cart = KZ.cart = {
    sectionId: 'kz-cart-drawer',
    lastFocus: null,
    drawer: function () { return $('[data-kz-drawer]'); },
    overlay: function () { return $('[data-kz-overlay]'); },
    onKey: function (e) {
      if (e.key === 'Escape') Cart.close();
      else trapFocus(Cart.drawer(), e);
    },
    open: function () {
      var d = this.drawer();
      if (!d) { window.location.href = KZ.routes.cart; return; }
      this.lastFocus = document.activeElement;
      d.classList.add('is-open');
      var o = this.overlay(); if (o) o.classList.add('is-open');
      lockScroll(true);
      setTimeout(function () { var c = $('[data-kz-drawer-close]', d); if (c) c.focus(); }, 60);
      document.addEventListener('keydown', this.onKey);
    },
    close: function () {
      var d = this.drawer();
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      var o = this.overlay(); if (o) o.classList.remove('is-open');
      lockScroll(false);
      document.removeEventListener('keydown', this.onKey);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    isOpen: function () { var d = this.drawer(); return !!(d && d.classList.contains('is-open')); },
    render: function (sections) {
      var html = sections && sections[this.sectionId];
      if (!html) return;
      var next = $('[data-kz-drawer-inner]', parse(html));
      var cur = $('[data-kz-drawer-inner]');
      if (next && cur) cur.replaceWith(next);
      if (next) this.setCount(parseInt(next.getAttribute('data-kz-count'), 10) || 0);
    },
    setCount: function (n) {
      $$('[data-kz-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
      $$('[data-kz-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
    },
    request: function (url, body) {
      body.sections = this.sectionId;
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || KZ.strings.error);
          return data;
        });
      });
    },
    add: function (items, btn) {
      var self = this;
      if (btn) btn.classList.add('is-loading');
      return this.request(KZ.routes.cartAdd + '.js', { items: items })
        .then(function (data) {
          self.render(data.sections);
          self.open();
          document.dispatchEvent(new CustomEvent('kz:cart:added', { detail: data }));
          return data;
        })
        .catch(function (err) { KZ.toast(err.message || KZ.strings.error); throw err; })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    },
    change: function (key, quantity) {
      var self = this;
      var line = $('[data-kz-line="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      if (line) line.classList.add('is-busy');
      return this.request(KZ.routes.cartChange + '.js', { id: key, quantity: quantity })
        .then(function (data) { self.render(data.sections); })
        .catch(function (err) { KZ.toast(err.message || KZ.strings.error); if (line) line.classList.remove('is-busy'); });
    }
  };

  document.addEventListener('click', function (e) {
    var t = e.target;
    var openBtn = t.closest('[data-kz-cart-open]');
    if (openBtn && Cart.drawer() && !document.body.classList.contains('template-cart')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('[data-kz-drawer-close]') || t.closest('[data-kz-overlay]')) { Cart.close(); return; }
    var q = t.closest('[data-kz-qty]');
    if (q) {
      var line = q.closest('[data-kz-line]');
      if (line) Cart.change(line.getAttribute('data-kz-line'), parseInt(q.getAttribute('data-kz-qty'), 10));
      return;
    }
    var add = t.closest('[data-kz-add]');
    if (add) { e.preventDefault(); Cart.add([{ id: Number(add.getAttribute('data-kz-add')), quantity: 1 }], add).catch(function () {}); return; }
    var acc = t.closest('[data-kz-open-acc]');
    if (acc) {
      var d = document.getElementById(acc.getAttribute('data-kz-open-acc'));
      if (d) { e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); var s = $('summary', d); if (s) s.focus({ preventScroll: true }); }
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-kz-quick-add]');
    if (!f) return;
    e.preventDefault();
    var id = $('[name="id"]', f).value;
    Cart.add([{ id: Number(id), quantity: 1 }], $('button', f)).catch(function () {});
  });

  /* ---------- Header ---------- */
  function initHeader() {
    var h = $('[data-kz-header]');
    if (h && !h.classList.contains('kz-header--overlay')) {
      var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 8); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      var setH = function () { document.documentElement.style.setProperty('--kz-header-h', h.offsetHeight + 'px'); };
      setH();
      window.addEventListener('resize', setH);
    }
    var burger = $('[data-kz-burger]'), nav = $('[data-kz-mnav]');
    if (!burger || !nav || burger.dataset.bound) return;
    burger.dataset.bound = '1';
    var onKey = function (e) { if (e.key === 'Escape') close(); else trapFocus(nav, e); };
    function close() {
      nav.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      document.removeEventListener('keydown', onKey);
      burger.focus();
    }
    burger.addEventListener('click', function () {
      nav.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      document.addEventListener('keydown', onKey);
      setTimeout(function () { var c = $('[data-kz-mnav-close]', nav); if (c) c.focus(); }, 60);
    });
    var c = $('[data-kz-mnav-close]', nav);
    if (c) c.addEventListener('click', close);
  }

  /* ---------- Rails ---------- */
  function initRails(root) {
    $$('[data-kz-rail]', root).forEach(function (rail) {
      if (rail.dataset.bound) return;
      rail.dataset.bound = '1';
      var bar = rail.parentElement.querySelector('[data-kz-rail-bar]');
      function update() {
        if (!bar) return;
        var max = rail.scrollWidth - rail.clientWidth;
        var w = Math.min(1, Math.max(rail.clientWidth / (rail.scrollWidth || 1), 0.08));
        bar.style.width = (w * 100) + '%';
        var p = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * ((1 - w) / w) * 100) + '%)';
      }
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      var down = false, sx = 0, sl = 0, moved = false;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft;
        rail.style.scrollSnapType = 'none';
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        if (Math.abs(e.clientX - sx) > 4) moved = true;
        rail.scrollLeft = sl - (e.clientX - sx);
      });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; rail.style.scrollSnapType = ''; });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- Footer big logo fit ---------- */
  function fitFooterLogo() {
    $$('.footer__big-logo-text').forEach(function (el) {
      var crop = el.closest('.footer__big-logo-crop'), fit = el.closest('.footer__big-logo-fit');
      if (!crop || !fit) return;
      el.style.setProperty('--fit', 1);
      crop.style.removeProperty('--cropH');
      var w = fit.getBoundingClientRect().width, tw = el.scrollWidth;
      if (!w || !tw) return;
      el.style.setProperty('--fit', w / tw);
      requestAnimationFrame(function () {
        var h = el.getBoundingClientRect().height;
        var pct = parseFloat(getComputedStyle(crop).getPropertyValue('--crop')) || 0;
        var cut = h * (pct / 100);
        crop.style.setProperty('--cropH', Math.max(0, h - cut) + 'px');
        el.style.setProperty('--cropShift', cut + 'px');
      });
    });
  }

  /* ---------- Collection ---------- */
  function initCollection() {
    var form = $('[data-kz-filter-form]');
    if (form && !form.dataset.bound) {
      form.dataset.bound = '1';
      var go = function () {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
        var qs = params.toString();
        window.location.href = form.getAttribute('action') + (qs ? '?' + qs : '');
      };
      form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
      var sort = $('[data-kz-sort]', form);
      if (sort) sort.addEventListener('change', go);
      $$('input[type="checkbox"]', form).forEach(function (i) { i.addEventListener('change', go); });
      var d = $('[data-kz-filters]', form);
      if (d) document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
    }
  }

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-kz-more]');
    if (!more) return;
    e.preventDefault();
    more.classList.add('is-loading');
    fetch(more.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parse(html);
        var grid = $('[data-kz-grid]');
        $$('[data-kz-grid] > li', doc).forEach(function (li) { grid.appendChild(li); });
        var wrap = $('[data-kz-more-wrap]'), next = $('[data-kz-more-wrap]', doc);
        if (wrap && next) { $$('[rel="prev"]', next).forEach(function (a) { a.remove(); }); wrap.replaceWith(next); }
        else if (wrap) wrap.remove();
        KZ.reveal(grid);
      })
      .catch(function () { window.location.href = more.href; });
  });

  /* ---------- Product ---------- */
  function largestSrc(img) {
    var best = img.currentSrc || img.src, w = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/), n = parseInt(bits[1], 10);
      if (n > w) { w = n; best = bits[0]; }
    });
    return best;
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime()), c = 0;
    while (c < n) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) c++; }
    return d;
  }

  function initProduct(root) {
    if (root.dataset.bound) return;
    var jsonEl = $('[data-kz-product-json]', root);
    if (!jsonEl) return;
    root.dataset.bound = '1';
    var P = JSON.parse(jsonEl.textContent);
    var form = $('form.kz-form', root);
    var idInput = $('[data-kz-variant-id]', root);
    var atc = $('[data-kz-atc]', root), atcLabel = $('[data-kz-atc-label]', root);
    var pre = root.getAttribute('data-kz-preorder');
    var atcWord = pre ? 'Pre-order' : KZ.strings.addToCart;
    var priceNow = $('[data-kz-price-now]', root), priceWas = $('[data-kz-price-was]', root), priceBadge = $('[data-kz-price-badge]', root);
    var stock = $('[data-kz-stock]', root);
    var sticky = $('[data-kz-sticky]', root), stickyBtn = $('[data-kz-sticky-btn]', root), stickyPrice = $('[data-kz-sticky-price]', root);
    var dyn = $('[data-kz-dynamic]', root);
    var list = $('[data-kz-gallery-list]', root);
    var variant = P.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || P.variants[0];
    var optionSets = $$('[data-kz-option]', root);

    function tierInput() { return $('input[name="kz_tier"]:checked', root); }
    function tierQty() { var t = tierInput(); return t ? parseInt(t.value, 10) : 1; }
    function tierPct() { var t = tierInput(); return t ? parseFloat(t.getAttribute('data-pct')) : 0; }
    function selected() { return optionSets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function find(opts) {
      return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0] || null;
    }

    function markAvailability() {
      var opts = selected();
      optionSets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = find(test);
          inp.closest('.kz-pill').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function render() {
      var q = tierQty(), pct = tierPct();
      var unit = variant ? variant.price : 0;
      $$('.kz-tier', root).forEach(function (lbl) {
        var inp = $('input', lbl), tq = parseInt(inp.value, 10), tp = parseFloat(inp.getAttribute('data-pct')) || 0;
        var full = unit * tq, now = Math.round(full * (100 - tp) / 100);
        var n = $('[data-kz-tier-now]', lbl), w = $('[data-kz-tier-was]', lbl), off = $('[data-kz-tier-off]', lbl), first = $('[data-kz-unit-first]', lbl);
        if (n) n.textContent = KZ.formatMoney(now);
        if (w) w.textContent = KZ.formatMoney(full);
        if (off) off.textContent = KZ.formatMoney(full - now);
        if (first && variant) first.textContent = variant.title;
      });
      if (!variant) {
        atc.disabled = true;
        atcLabel.textContent = 'Unavailable';
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = variant.id;
      var sale = variant.compare_at_price > variant.price;
      priceNow.textContent = KZ.formatMoney(variant.price);
      priceNow.classList.toggle('kz-sale', sale);
      if (priceWas) { priceWas.hidden = !sale; if (sale) priceWas.textContent = KZ.formatMoney(variant.compare_at_price); }
      if (priceBadge) priceBadge.hidden = !sale;
      var total = Math.round(variant.price * q * (100 - pct) / 100);
      atc.disabled = !variant.available;
      atcLabel.textContent = variant.available ? atcWord + ' · ' + KZ.formatMoney(total) : KZ.strings.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = variant.available ? atcWord : KZ.strings.soldOut; }
      if (stickyPrice) stickyPrice.textContent = KZ.formatMoney(total) + (q > 1 ? ' · ' + q + ' items' : '');
      if (dyn) dyn.hidden = q > 1;
      if (stock) {
        var cls = 'kz-stock', txt = pre ? 'Pre-order · ships in 1–2 weeks due to high demand' : 'In stock, ready to make';
        if (!variant.available) { cls += ' kz-stock--out'; txt = 'Sold out — join the list for the restock'; }
        else if (variant.inventory !== null && variant.inventory <= P.lowStock) { cls += ' kz-stock--low'; txt = 'Only ' + variant.inventory + ' left — limited run'; }
        stock.className = cls;
        stock.textContent = txt;
      }
      optionSets.forEach(function (fs, i) { var l = $('[data-kz-option-value]', fs); if (l) l.textContent = variant.options[i]; });
    }

    function scrollToMedia(id) {
      if (!list || !id) return;
      var li = $('[data-media-id="' + id + '"]', list);
      if (!li) return;
      if (window.matchMedia('(max-width: 989px)').matches) list.scrollTo({ left: li.offsetLeft, behavior: 'smooth' });
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.closest('[data-kz-option]')) {
        variant = find(selected());
        markAvailability();
        if (variant) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
          scrollToMedia(variant.media_id);
          $$('[data-kz-unit-select]', root).forEach(function (s) { if (!s.dataset.touched) s.value = variant.id; });
        }
        render();
      } else if (t.name === 'kz_tier') {
        render();
      } else if (t.matches('[data-kz-unit-select]')) {
        t.dataset.touched = '1';
      }
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variant || !variant.available) return;
      var q = tierQty();
      var ids = [variant.id];
      var t = tierInput();
      if (q > 1) {
        var sels = t ? $$('[data-kz-unit-select]', t.closest('.kz-tier')) : [];
        if (sels.length) sels.forEach(function (s) { ids.push(Number(s.value)); });
        else for (var i = 1; i < q; i++) ids.push(variant.id);
      }
      var counts = {};
      ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { var it = { id: Number(id), quantity: counts[id] }; if (pre) it.properties = { Shipping: pre }; return it; });
      Cart.add(items, atc).catch(function () {});
    });

    if (stickyBtn && form) stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });

    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }).observe(atc);
    }

    // Gallery dots (mobile carousel)
    var dots = $$('.kz-gallery__dot', root);
    if (list && dots.length && 'IntersectionObserver' in window) {
      var items = Array.prototype.slice.call(list.children);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            var i = items.indexOf(en.target);
            dots.forEach(function (d, j) { d.setAttribute('aria-current', String(i === j)); });
          }
        });
      }, { root: list, threshold: [0.6] });
      items.forEach(function (it) { io.observe(it); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { list.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' }); }); });
    }

    // Lightbox
    var lb = $('[data-kz-lightbox]', root), lbImg = $('[data-kz-lightbox-img]', root);
    if (list && lb && lb.showModal) {
      list.addEventListener('click', function (e) {
        var img = e.target.closest('img');
        if (!img) return;
        lbImg.src = largestSrc(img);
        lbImg.alt = img.alt;
        lb.showModal();
      });
      $('[data-kz-lightbox-close]', lb).addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbImg) lb.close(); });
    }

    // Delivery estimate
    var eta = $('[data-kz-eta]', root);
    if (eta) {
      var now = new Date();
      var lo = addBusinessDays(now, (+eta.getAttribute('data-pmin')) + (+eta.getAttribute('data-tmin')));
      var hi = addBusinessDays(now, (+eta.getAttribute('data-pmax')) + (+eta.getAttribute('data-tmax')));
      var f = function (d) { return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); };
      $('span', eta).textContent = (pre ? 'Pre-order · ships in 1–2 weeks due to high demand · est. delivery ' : 'Order today — estimated delivery ') + f(lo) + ' – ' + f(hi);
    }

    // Complete the set
    var up = $('[data-kz-upsell]', root);
    if (up && KZ.routes.recommendations) {
      var limit = parseInt(up.getAttribute('data-limit'), 10) || 3;
      var load = function (intent) {
        return fetch(KZ.routes.recommendations + '?section_id=kz-upsell&product_id=' + P.id + '&limit=' + (limit + 1) + '&intent=' + intent)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) { return t ? $$('[data-kz-upsell-item]', parse(t)) : []; })
          .catch(function () { return []; });
      };
      var run = function () {
        load('complementary').then(function (items) { return items.length ? items : load('related'); }).then(function (items) {
          if (!items.length) return;
          var ul = $('[data-kz-upsell-list]', up);
          items.slice(0, limit).forEach(function (li) { ul.appendChild(li); });
          up.hidden = false;
        });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 }); else setTimeout(run, 1200);
    }

    markAvailability();
    render();
  }

  /* ---------- Recommendations grid ---------- */
  function initRecs() {
    $$('[data-kz-recs]').forEach(function (el) {
      if (el.dataset.bound || $('.kz-grid', el) || !el.getAttribute('data-url') || /product_id=&/.test(el.getAttribute('data-url'))) return;
      el.dataset.bound = '1';
      var load = function () {
        fetch(el.getAttribute('data-url'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var n = $('[data-kz-recs]', parse(html));
            if (n && $('.kz-grid', n)) { el.innerHTML = n.innerHTML; KZ.reveal(el); }
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
        io.observe(el);
      } else load();
    });
  }

  /* ---------- Email + SMS popup (with tier list game) ---------- */
  var TIER_COLORS = { S: '#b3261e', A: '#c8612b', B: '#c99a2e', C: '#3f7a63', D: '#3d5a80' };
  var TIER_KEYS = ['S', 'A', 'B', 'C', 'D'];

  function initPopup() {
    var pop = $('[data-kz-pop]');
    if (!pop || !pop.showModal || pop.dataset.bound) return;
    pop.dataset.bound = '1';
    var teaser = $('[data-kz-teaser]');
    var LS = 'kzPop';
    function getState() { try { return JSON.parse(localStorage.getItem(LS) || '{}'); } catch (e) { return {}; } }
    function setState(v) { try { localStorage.setItem(LS, JSON.stringify(v)); } catch (e) {} }
    var days = parseInt(pop.getAttribute('data-suppress'), 10) || 14;
    var klKey = pop.getAttribute('data-kl-key'), klList = pop.getAttribute('data-kl-list');
    var sheetUrl = pop.getAttribute('data-sheet');
    var smsOn = pop.getAttribute('data-sms') === 'true' && !!klKey && !!klList;
    var gameOn = pop.getAttribute('data-game') === 'true' && !!$('[data-step="game"]', pop);
    var steps = { game: $('[data-step="game"]', pop), email: $('[data-step="email"]', pop), sms: $('[data-step="sms"]', pop), done: $('[data-step="done"]', pop) };
    var email = '';
    if (!smsOn) { var d2 = $('[data-dot="2"]', pop); if (d2) d2.remove(); }
    var firstStep = gameOn ? 'game' : 'email';

    /* --- tier list state --- */
    var tl = { id: null, data: null, custom: [] };
    try { tl.id = sessionStorage.getItem('kzTlId'); } catch (e) {}
    if (!tl.id) {
      tl.id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'tl-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      try { sessionStorage.setItem('kzTlId', tl.id); } catch (e) {}
    }
    try { var savedTl = JSON.parse(sessionStorage.getItem('kzTlData') || 'null'); if (savedTl) { tl.data = savedTl.data; tl.custom = savedTl.custom || []; } } catch (e) {}

    function show(name) {
      Object.keys(steps).forEach(function (k) { if (steps[k]) steps[k].hidden = k !== name; });
      pop.classList.toggle('kz-pop--game', name === 'game');
      var n = { game: 0, email: 1, sms: 2, done: 3 }[name];
      $$('[data-dot]', pop).forEach(function (d) { d.classList.toggle('is-on', +d.getAttribute('data-dot') <= n); });
      var share = $('[data-kz-tl-share]', pop);
      if (share) share.hidden = !(name === 'done' && tl.data);
      var focusEl = steps[name] && $('input:not([type="hidden"]):not([data-kz-cc]):not(#kz-tl-new), .kz-btn:not([disabled])', steps[name]);
      if (focusEl && pop.open && name !== 'game') setTimeout(function () { focusEl.focus(); }, 60);
    }
    function otherPopupVisible() {
      return $$('.klaviyo-form, [aria-label*="POPUP" i], [aria-label*="FLYOUT" i]').some(function (el) {
        var r = el.getBoundingClientRect();
        return r.width > 40 && r.height > 40 && getComputedStyle(el).visibility !== 'hidden';
      });
    }
    var lastAct = 0;
    ['pointerdown', 'keydown'].forEach(function (ev) { document.addEventListener(ev, function () { lastAct = Date.now(); }, { capture: true, passive: true }); });
    function open(step, auto) {
      if (pop.open) return;
      if (auto && Date.now() - lastAct < 4000) { setTimeout(function () { open(step, true); }, 4000); return; }
      if (auto && otherPopupVisible()) { if (teaser) teaser.hidden = false; return; }
      if (auto && (Cart.isOpen() || document.querySelector('dialog[open]'))) { setTimeout(function () { open(step, true); }, 8000); return; }
      show(step || firstStep);
      pop.showModal();
      if (teaser) teaser.hidden = true;
      show(step || firstStep);
    }
    function close() { pop.close(); }

    pop.addEventListener('close', function () {
      var s = getState();
      if (s.state !== 'subscribed') { setState({ state: 'closed', t: Date.now() }); if (teaser) teaser.hidden = false; }
    });
    $$('[data-kz-pop-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    if (teaser) teaser.addEventListener('click', function () { open(getState().state === 'subscribed' ? 'done' : firstStep); });

    /* --- storage --- */
    function klaviyo(p) {
      if (!klKey || !klList) return Promise.resolve();
      var attrs = { subscriptions: {} };
      if (p.email) { attrs.email = p.email; attrs.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } }; }
      if (p.phone) { attrs.phone_number = p.phone; attrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
      return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(klKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'KIZUNA tier list popup', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: klList } } } } })
      }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); });
    }
    function klaviyoTierEvent(addr) {
      if (!klKey || !tl.data || !addr) return Promise.resolve();
      var top = tl.data.S[0] || tl.data.A[0] || tl.data.B[0] || '';
      var props = { submission_id: tl.id, write_ins: tl.custom, shows_ranked: placedCount(tl.data), top_show: top };
      TIER_KEYS.forEach(function (t) { props['tier_' + t] = tl.data[t]; });
      return fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(klKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Submitted Tier List' } } },
          profile: { data: { type: 'profile', attributes: { email: addr, properties: {
            tierlist_S: tl.data.S, tierlist_A: tl.data.A, tierlist_B: tl.data.B, tierlist_C: tl.data.C, tierlist_D: tl.data.D,
            tierlist_top_show: top, tierlist_write_ins: tl.custom
          } } } }
        } } })
      }).catch(function () {});
    }
    function sheet(extra) {
      if (!sheetUrl || !tl.data) return;
      var payload = { id: tl.id, tiers: tl.data, custom: tl.custom, page: location.pathname, device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop' };
      Object.keys(extra || {}).forEach(function (k) { payload[k] = extra[k]; });
      try {
        fetch(sheetUrl, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) });
      } catch (e) {}
    }

    /* --- tier list game --- */
    function placedCount(data) { return TIER_KEYS.reduce(function (n, t) { return n + ((data && data[t]) || []).length; }, 0); }
    var board = $('[data-kz-tl]', pop), bench = $('[data-kz-tl-bench]', pop);
    if (gameOn && board && bench) {
      var min = parseInt(pop.getAttribute('data-min'), 10) || 3;
      var saveBtn = $('[data-kz-tl-save]', pop), hint = $('[data-kz-tl-hint]', pop), err = $('[data-kz-tl-err]', pop);
      var saveLabel = saveBtn.textContent;
      var selected = null;

      function chips() { return $$('[data-kz-chip]', pop); }
      function select(chip) {
        if (selected) selected.setAttribute('aria-pressed', 'false');
        selected = chip && chip !== selected ? chip : null;
        if (selected) selected.setAttribute('aria-pressed', 'true');
        board.classList.toggle('has-selection', !!selected);
        hint.textContent = selected ? 'Now tap a tier for “' + selected.textContent + '”.' : 'Tap a show, then tap a tier. On desktop you can drag.';
      }
      function place(chip, tier) {
        var zone = tier ? $('[data-kz-tl-drop="' + tier + '"]', board) : bench;
        if (!zone || !chip) return;
        zone.appendChild(chip);
        select(null);
        update();
      }
      function update() {
        var n = $$('[data-kz-tl-drop] [data-kz-chip]', board).length;
        saveBtn.disabled = n < min;
        saveBtn.textContent = n < min ? saveLabel + ' (' + n + '/' + min + ')' : 'Save my tier list';
      }
      update();

      pop.addEventListener('click', function (e) {
        if (Date.now() - (pop._dragEnd || 0) < 250) return;
        var chip = e.target.closest('[data-kz-chip]');
        if (chip && pop.contains(chip)) { e.preventDefault(); select(chip); return; }
        var label = e.target.closest('[data-kz-tl-place]');
        var drop = e.target.closest('[data-kz-tl-drop]');
        if (selected && (label || drop)) { place(selected, (label || drop).getAttribute(label ? 'data-kz-tl-place' : 'data-kz-tl-drop')); return; }
        if (selected && e.target.closest('[data-kz-tl-bench]')) place(selected, null);
      });

      // Mouse drag (touch uses tap-to-place so the popup can still scroll)
      var drag = null;
      pop.addEventListener('pointerdown', function (e) {
        var chip = e.target.closest('[data-kz-chip]');
        if (!chip || e.pointerType !== 'mouse' || e.button !== 0) return;
        var r = chip.getBoundingClientRect();
        drag = { chip: chip, x: e.clientX, y: e.clientY, dx: e.clientX - r.left, dy: e.clientY - r.top, w: r.width, moving: false };
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        if (!drag.moving) {
          if (Math.abs(e.clientX - drag.x) + Math.abs(e.clientY - drag.y) < 6) return;
          drag.moving = true;
          drag.chip.classList.add('is-dragging');
          drag.chip.style.width = drag.w + 'px';
        }
        drag.chip.style.left = (e.clientX - drag.dx) + 'px';
        drag.chip.style.top = (e.clientY - drag.dy) + 'px';
        $$('.kz-tl__drop.is-over', board).forEach(function (z) { z.classList.remove('is-over'); });
        var under = document.elementFromPoint(e.clientX, e.clientY);
        var z = under && under.closest('[data-kz-tl-drop]');
        if (z) z.classList.add('is-over');
      });
      window.addEventListener('pointerup', function (e) {
        if (!drag) return;
        var d = drag; drag = null;
        if (!d.moving) return;
        d.chip.classList.remove('is-dragging');
        d.chip.style.width = d.chip.style.left = d.chip.style.top = '';
        $$('.kz-tl__drop.is-over', board).forEach(function (z) { z.classList.remove('is-over'); });
        var under = document.elementFromPoint(e.clientX, e.clientY);
        var zone = under && (under.closest('[data-kz-tl-drop]') || under.closest('[data-kz-tl-place]'));
        var tier = zone ? (zone.getAttribute('data-kz-tl-drop') || zone.getAttribute('data-kz-tl-place')) : null;
        place(d.chip, tier);
        pop._dragEnd = Date.now();
      });

      var addForm = $('[data-kz-tl-add]', pop);
      addForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = $('input', addForm);
        var name = input.value.replace(/\s+/g, ' ').replace(/[<>]/g, '').trim().slice(0, 40);
        err.textContent = '';
        if (name.length < 2) { err.textContent = 'Type a show name first.'; input.focus(); return; }
        if (/https?:|www\.|\.com\b/i.test(name)) { err.textContent = 'Just the show name, no links.'; return; }
        var existing = chips().filter(function (c) { return c.textContent.trim().toLowerCase() === name.toLowerCase(); })[0];
        if (existing) { select(existing); input.value = ''; hint.textContent = '“' + existing.textContent + '” is already here — tap a tier for it.'; return; }
        if (tl.custom.length >= 6) { err.textContent = 'You can add up to 6 of your own shows.'; return; }
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'kz-tl__chip is-custom';
        chip.setAttribute('data-kz-chip', '');
        chip.setAttribute('data-custom', '');
        chip.setAttribute('aria-pressed', 'false');
        chip.textContent = name;
        bench.insertBefore(chip, bench.firstChild);
        tl.custom.push(name);
        input.value = '';
        select(chip);
      });

      function collect() {
        var data = {};
        TIER_KEYS.forEach(function (t) {
          data[t] = $$('[data-kz-tl-drop="' + t + '"] [data-kz-chip]', board).map(function (c) { return c.textContent.trim(); });
        });
        var usedCustom = tl.custom.filter(function (name) { return TIER_KEYS.some(function (t) { return data[t].indexOf(name) > -1; }); });
        return { data: data, custom: usedCustom };
      }
      saveBtn.addEventListener('click', function () {
        if (saveBtn.disabled) return;
        var c = collect();
        tl.data = c.data;
        tl.custom = c.custom;
        try { sessionStorage.setItem('kzTlData', JSON.stringify({ data: tl.data, custom: tl.custom })); } catch (e) {}
        sheet();
        document.dispatchEvent(new CustomEvent('kz:tierlist', { detail: { tiers: tl.data, custom: tl.custom } }));
        show('email');
      });
      $('[data-kz-tl-skip]', pop).addEventListener('click', function () { show('email'); });
    }

    /* --- share image --- */
    var shareBtn = $('[data-kz-tl-share]', pop);
    if (shareBtn) shareBtn.addEventListener('click', function () {
      if (!tl.data) return;
      renderTierImage(tl.data).then(function (blob) {
        var file = new File([blob], 'my-kizuna-tier-list.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          return navigator.share({ files: [file], title: 'My all-time tier list', text: 'My all-time anime tier list — kizunala.com' }).catch(function () {});
        }
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'my-kizuna-tier-list.png';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
      });
    });

    /* --- email --- */
    var form = $('#kz-pop-form', pop), err2 = $('[data-kz-pop-err]', pop);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input[type="email"]', form), v = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        err2.textContent = 'Enter a valid email address.';
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      err2.textContent = '';
      input.removeAttribute('aria-invalid');
      email = v;
      var btn = $('button[type="submit"]', form);
      btn.classList.add('is-loading');
      sheet({ email: v });
      var kl = klaviyo({ email: v }).catch(function () {}).then(function () { return klaviyoTierEvent(v); });
      var shop = fetch(form.getAttribute('action'), { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (res) { return !(res.url && /challenge/.test(res.url)); })
        .catch(function () { return false; });
      Promise.all([shop, kl]).then(function (r) {
        btn.classList.remove('is-loading');
        if (!r[0]) {
          try { sessionStorage.setItem('kzPopPending', v); } catch (x) {}
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        setState({ state: 'subscribed', t: Date.now() });
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: v }); } catch (x) {}
        show(smsOn ? 'sms' : 'done');
      });
    });

    /* --- sms --- */
    var sms = $('[data-kz-sms-form]', pop);
    if (sms) sms.addEventListener('submit', function (e) {
      e.preventDefault();
      var serr = $('[data-kz-sms-err]', sms);
      var cc = ($('[data-kz-cc]', sms).value || '+1').replace(/[^\d+]/g, '');
      if (cc.charAt(0) !== '+') cc = '+' + cc;
      var digits = $('#kz-pop-phone', sms).value.replace(/\D/g, '');
      if (cc === '+1' && digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      if ((cc === '+1' && digits.length !== 10) || digits.length < 7) { serr.textContent = 'Enter a valid mobile number.'; return; }
      serr.textContent = '';
      var phone = cc + digits;
      var btn = $('button[type="submit"]', sms);
      btn.classList.add('is-loading');
      sheet({ email: email, phone: phone, sms: true });
      klaviyo({ email: email, phone: phone })
        .then(function () {
          if (form) {
            var fd = new FormData();
            fd.append('form_type', 'customer');
            fd.append('utf8', '✓');
            fd.append('contact[email]', email);
            fd.append('contact[tags]', 'newsletter, popup, sms-optin' + (gameOn ? ', tier-list-popup' : ''));
            fetch(form.getAttribute('action'), { method: 'POST', body: fd }).catch(function () {});
          }
          show('done');
        })
        .catch(function (err) { if (window.console) console.warn('[KIZUNA] SMS signup failed', err); show('done'); })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
    var skip = $('[data-kz-sms-skip]', pop);
    if (skip) skip.addEventListener('click', function () { show('done'); });

    var copy = $('[data-kz-copy]', pop);
    if (copy) copy.addEventListener('click', function () {
      var code = pop.getAttribute('data-code');
      var done = function () { copy.textContent = 'Copied'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });

    /* --- triggers --- */
    var url = new URL(window.location.href), pending = null;
    try { pending = sessionStorage.getItem('kzPopPending'); } catch (x) {}
    if (pending && url.searchParams.get('customer_posted') === 'true') {
      try { sessionStorage.removeItem('kzPopPending'); } catch (x) {}
      email = pending;
      setState({ state: 'subscribed', t: Date.now() });
      klaviyoTierEvent(pending);
      open(smsOn ? 'sms' : 'done');
      return;
    }

    var st = getState();
    var suppressed = st.state === 'subscribed' || (st.state === 'closed' && Date.now() - (st.t || 0) < days * 864e5);
    if (teaser && st.state === 'closed' && suppressed) teaser.hidden = false;
    if (pop.getAttribute('data-design') === 'true') { open(firstStep); return; }
    if (suppressed) return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var delay = (parseInt(pop.getAttribute(mobile ? 'data-mobile-delay' : 'data-delay'), 10) || 10) * 1000;
    var timer = setTimeout(function () { open(firstStep, true); }, delay);
    if (!mobile && pop.getAttribute('data-exit') === 'true') {
      setTimeout(function () {
        var onLeave = function (e) {
          if (e.clientY <= 0 && !e.relatedTarget) {
            document.removeEventListener('mouseout', onLeave);
            clearTimeout(timer);
            open(firstStep, true);
          }
        };
        document.addEventListener('mouseout', onLeave);
      }, 4000);
    }
  }

  /* Draws the tier list as a 1080px-wide PNG for sharing. */
  function renderTierImage(data) {
    var W = 1080, pad = 64, labelW = 120, gap = 14, chipH = 64, chipPad = 26, rowPad = 16;
    var root = getComputedStyle(document.documentElement);
    var headFont = (root.getPropertyValue('--font-heading-family') || 'Arial Narrow, sans-serif').trim();
    var c = document.createElement('canvas');
    var ctx = c.getContext('2d');
    var chipFont = '600 30px ' + headFont;
    ctx.font = chipFont;
    var innerW = W - pad * 2 - labelW - gap;
    var rows = TIER_KEYS.map(function (t) {
      var lines = [[]], x = 0;
      (data[t] || []).forEach(function (name) {
        var w = Math.min(ctx.measureText(name.toUpperCase()).width + chipPad * 2, innerW - rowPad * 2);
        if (x + w > innerW - rowPad * 2 && lines[lines.length - 1].length) { lines.push([]); x = 0; }
        lines[lines.length - 1].push({ name: name, w: w });
        x += w + 12;
      });
      var h = Math.max(120, lines.length * (chipH + 12) - 12 + rowPad * 2);
      return { t: t, lines: lines, h: h };
    });
    var top = 250;
    var H = Math.max(1350, top + rows.reduce(function (s, r) { return s + r.h + gap; }, 0) + 150);
    c.width = W; c.height = H;
    ctx.fillStyle = '#f7f6f2'; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = '#141312';
    ctx.font = '700 36px ' + headFont; ctx.textBaseline = 'alphabetic';
    ctx.fillText('KIZUNA  絆', pad, 110);
    ctx.font = '700 84px ' + headFont;
    ctx.fillText('MY ALL-TIME TIER LIST', pad, 200);
    var y = top;
    rows.forEach(function (r) {
      ctx.fillStyle = TIER_COLORS[r.t];
      ctx.fillRect(pad, y, labelW, r.h);
      ctx.fillStyle = '#ffffff';
      ctx.font = '700 64px ' + headFont; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText(r.t, pad + labelW / 2, y + r.h / 2 + 4);
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(pad + labelW + gap, y, innerW, r.h);
      ctx.textAlign = 'left';
      ctx.font = chipFont;
      r.lines.forEach(function (line, li) {
        var x = pad + labelW + gap + rowPad, cy = y + rowPad + li * (chipH + 12);
        line.forEach(function (chip) {
          ctx.fillStyle = '#141312';
          if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(x, cy, chip.w, chipH, 32); ctx.fill(); } else { ctx.fillRect(x, cy, chip.w, chipH); }
          ctx.fillStyle = '#f7f6f2';
          ctx.save(); ctx.beginPath(); ctx.rect(x + 12, cy, chip.w - 24, chipH); ctx.clip();
          ctx.fillText(chip.name.toUpperCase(), x + chipPad, cy + chipH / 2 + 2);
          ctx.restore();
          x += chip.w + 12;
        });
      });
      y += r.h + gap;
    });
    ctx.fillStyle = '#67635c'; ctx.font = '500 30px ' + headFont; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
    ctx.fillText('MAKE YOURS AT KIZUNALA.COM', pad, H - 70);
    return new Promise(function (resolve) { c.toBlob(resolve, 'image/png'); });
  }

  /* ---------- Boot ---------- */
  function boot(root) {
    initHeader();
    $$('[data-kz-product]', root).forEach(initProduct);
    initRecs();
    initRails(root);
    initCollection();
    initPopup();
    KZ.reveal(root);
    fitFooterLogo();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  window.addEventListener('resize', function () { clearTimeout(KZ._fitT); KZ._fitT = setTimeout(fitFooterLogo, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitFooterLogo);
  window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.close(); });

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    $$('[data-bound]', t).forEach(function (el) { delete el.dataset.bound; });
    boot(t);
    if (t.id === 'shopify-section-kz-cart-drawer') Cart.open();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.id === 'shopify-section-kz-cart-drawer') Cart.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.id === 'shopify-section-kz-cart-drawer') Cart.close();
  });
})();
